import { useContext, useEffect, useMemo, useState } from "react"
import { ToastContext } from "../../../context/ToastContext";
import services from "../../../services/services";
import { Urls } from "../../../services/Urls";
import { calculateWordsFromString, convertDynamicDate } from "../../../utils/Helper";
import _ from "underscore";

export const useLateArrival = ({ selectedData, setSelectedData, setPopupOpen, GetEmployeeAttandance, currentUser }) => {

    const { showInfo, showSuccess, showError } = useContext(ToastContext)
    const [reason, setReason] = useState('');
    const [shiftTime, setShiftTime] = useState({
        shiftStartDate: '',
        shiftEndDate: '',
    })
    const [words, setWords] = useState({
        totalWords: 0,
        expectedWords: 10
    })

    // this function set the reason and manage the word count
    const handleOnChange = (value) => {
        setReason(value)
        const wordsData = value?.trim()?.split(' ').filter(word => word !== '');
        if (wordsData.length > 0) {
            setWords({ ...words, totalWords: wordsData.length })
        }
    }

    useEffect(() => {
        const shift_startdate = selectedData?.shift_time?.split('-')?.[0]
        const shift_enddate = selectedData?.shift_time?.split('-')?.[1]
        setShiftTime({
            shiftStartDate: shift_startdate,
            shiftEndDate: shift_enddate
        })
        selectedData?.remark && selectedData?.remark !== undefined && handleOnChange(selectedData?.remark)
    }, [selectedData])

    // API calling for submit reason
    const handleSubmitReason = async (fromNotification, data, reasonData, fromTapTik, taptikType) => {
        let payload = {};
        if (fromNotification) {
            if (data?.is_late_in && !data?.in_remark && _.isEmpty(reasonData?.in_reason_opt)) {
                showInfo("info", "Please select Late In reason");
                return;
            } else if (reasonData?.in_reason_opt?.reason_type_key === "other" && (calculateWordsFromString(reasonData?.in_reason_text) < 10 || !reasonData?.in_reason_text)) {
                showInfo("info", "Late In reason should contain more than 10 words");
                return;
            } else if (data?.is_early_out && !data?.out_remark && _.isEmpty(reasonData?.out_reason_opt)) {
                showInfo("info", "Please select Early Out reason");
                return;
            } else if (reasonData?.out_reason_opt?.reason_type_key === "other" && (calculateWordsFromString(reasonData?.out_reason_text) < 10 || !reasonData?.out_reason_text)) {
                showInfo("info", "Early Out reason should contain more than 10 words");
                return;
            }
            const shift_startdate = data?.shift_time?.split('-')?.[0]
            const shift_enddate = data?.shift_time?.split('-')?.[1]
            payload = {
                "employee_id": data?.employee_id,
                "shift_date": convertDynamicDate(data?.shift_date) || "",
                "shift_startdate": shift_startdate || "",
                "shift_enddate": shift_enddate || "",
                "in_time": data?.in_time || "",
                "out_time": data?.out_time || "",
                "in_reason_id": reasonData?.in_reason_opt?.reason_id ? reasonData?.in_reason_opt?.reason_id : data?.in_reason_id || 0,
                "out_reason_id": reasonData?.out_reason_opt?.reason_id ? reasonData?.out_reason_opt?.reason_id : data?.out_reason_id || 0,
                "in_remark": reasonData?.in_reason_opt ? (reasonData?.in_reason_opt?.reason_type_key === "other" ? reasonData?.in_reason_text : reasonData?.in_reason_opt?.reasons) : data?.in_remark || "",
                "out_remark": reasonData?.out_reason_opt ? (reasonData?.out_reason_opt?.reason_type_key === "other" ? reasonData?.out_reason_text : reasonData?.out_reason_opt?.reasons) : data?.out_remark || ""
            }
        } else if (fromTapTik) {
            if(data?.in_reason_id !== 0 && taptikType?.type === "I" && taptikType?.selected_remark?.reason_type_key === "other" && calculateWordsFromString(data?.in_remark) < 10) {
                showInfo("Info", "Late In reason should contain more than 10 words");
                return;
            } else if(data?.out_reason_id !== 0 && taptikType?.type === "O" && taptikType?.selected_remark?.reason_type_key === "other" && calculateWordsFromString(data?.out_remark) < 10) {
                showInfo("Info", "Early Out reason should contain more than 10 words");
                return;
            }
            payload = data;
        } else {
            if (selectedData?.remark === reason?.trim()) {
                showInfo("info", "No changes made");
                return
            }
            if (!reason?.trim()) {
                showInfo("info", "Please enter reason.");
                return
            }
            if (words?.totalWords < 10) {
                showInfo("info", "Reason should contain more than 10 words");
                return
            }
            payload = {
                "employee_id": selectedData?.employee_id,
                "shift_date": convertDynamicDate(selectedData?.shift_date) || "",
                "shift_startdate": shiftTime?.shiftStartDate || "",
                "shift_enddate": shiftTime?.shiftEndDate || "",
                "in_time": selectedData?.in_time || "",
                "out_time": selectedData?.out_time || "",
                // "remark": reason,
                // "reason_id": 0,
                "in_reason_id": 0,
                "out_reason_id": 0,
                "in_remark": "",
                "out_remark": ""

            }
        }
        try {
            const res = await services.getInvokeRemote("POST", Urls("UPSERTEMPLOYEEATTANDANCE"), payload);
            if (res?.body?.error_status === false) {
                showSuccess("success", res?.body?.message)
                if (!fromNotification && !fromTapTik) {
                    setSelectedData({});
                    setPopupOpen(false);
                    GetEmployeeAttandance(currentUser);
                }
                if (fromNotification || fromTapTik) {
                    return true;
                }
                setReason("");
            } else {
                showError("error", res?.body?.errorMessage)
            }
        }
        catch (error) {
            console.error("Error: ", error);
        }
    }


    return useMemo(() => ({
        reason, words, handleOnChange, handleSubmitReason, setReason, shiftTime
    }), [reason, words, handleOnChange, handleSubmitReason, setReason, shiftTime])
}